import { Navigate, Outlet, useLocation } from 'react-router'
import { useAppSelector } from 'universal-scripts'

export default function RequireAuth() {
  const isLoggedIn = useAppSelector((state) => !!state.user)
  const location = useLocation()

  if (!isLoggedIn) {
    if (__SERVER__) {
      return null
    }
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  return <Outlet />
}
